import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { BASE_IMG_URL } from '@images/imageUrls';
import styles from './RecommendedSearchInput.module.scss';

interface RecommendedSearchInputProps {
    value: string;
    keywords: string[];
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSearch: (keyword: string) => void;
    inputClassName?: string;
    iconClassName?: string;
}

const RecommendedSearchInput = ({ value, keywords, onChange, onSearch, inputClassName, iconClassName }: RecommendedSearchInputProps) => {
    const [index, setIndex] = useState(0);
    const [focused, setFocused] = useState(false);
    const currentKeyword = keywords[index % keywords.length] || '';

    useEffect(() => {
        if (value || focused || keywords.length < 2) return;
        const timer = window.setInterval(() => setIndex(previous => (previous + 1) % keywords.length), 3000);
        return () => window.clearInterval(timer);
    }, [value, focused, keywords.length]);

    const submit = () => {
        const keyword = value.trim() || currentKeyword;
        if (keyword) onSearch(keyword);
    };

    return <div className={styles.root}>
        <button type="button" className={styles.searchButton} aria-label="搜索" onClick={submit}>
            <img src={`${BASE_IMG_URL}/common/search.png`} alt="" className={iconClassName} />
        </button>
        <div className={styles.inputArea}>
            <Input
                className={inputClassName}
                aria-label="搜索关键词"
                placeholder={currentKeyword ? '' : '搜索'}
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                onPressEnter={event => {
                    if (!event.nativeEvent.isComposing) submit();
                }}
            />
            {!value && currentKeyword && <div className={styles.hint} aria-hidden="true">
                <span key={currentKeyword} className={styles.keyword}>{currentKeyword}</span>
            </div>}
        </div>
    </div>;
};

export default RecommendedSearchInput;
